@if (icon) {
  <div
    class="icon"
    [class.icon-red]="iconColor === 'red'"
    [class.icon-yellow]="iconColor === 'yellow'">
    <i [class]="icon"></i>
  </div>
}
<span class="font-medium-title-large">{{ title }}</span>
@if (htmlMessage) {
  <span
    class="font-regular-body-large text-center message-text"
    [innerHTML]="message | sanitizeHtml">
  </span>
} @else {
  <span class="font-regular-body-large text-center message-text">
    {{ message }}
  </span>
}
<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    [class]="
      cancelButtonIcon
        ? 'inwi-icon-text-button-large-secondary'
        : 'inwi-text-button-large-secondary'
    "
    (click)="closeDialog(false)">
    <div class="button-content">
      @if (cancelButtonIcon) {
        <div class="button-icon">
          <i [class]="cancelButtonIcon"></i>
        </div>
      }
      <div class="button-text">{{ cancelButtonText }}</div>
    </div>
  </button>
  <button
    type="button"
    (click)="closeDialog(true)"
    [class]="
      confirmButtonIcon
        ? 'inwi-icon-text-button-large-primary'
        : 'inwi-text-button-large-primary'
    ">
    <div class="button-content">
      @if (confirmButtonIcon) {
        <div class="button-icon">
          <i [class]="confirmButtonIcon"></i>
        </div>
      }
      <div class="button-text">{{ confirmButtonText }}</div>
    </div>
  </button>
</div>
